module.exports = __webpack_public_path__ + "img/intro.bf508a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mlstudio/intro.svg
// module id = 6sXR
// module chunks = 39 44